import React, { useState, useContext, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Alert from 'react-s-alert';
import moment from 'moment';
import Joyride, { STATUS } from 'react-joyride';

// import contexts
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// import services
import DemoService from '../../../services/DemoService';
import GeneralService from '../../../services/GeneralService';

// local imports
import ErrorBoundary from '../../general/ErrorBoundary';
import ClientNavbar from './ClientNavbar';
import Footer from '../../general/Footer';
import { clients } from '../demoData';

const ViewClientProfile = props => {

    // contexts
    const { theme, fontSize, colors, fontFamily, fontWeight } = useContext(ThemeContext);
    const { selectedTimeZone } = useContext(AuthContext);

    // states
    const [user, setUser] = useState({ firstName: "", lastName: "", email: "", selectedRole: '', roles: [], profileImage: "", demoTakenFor: [] });
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [client, setClient] = useState({})
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <h2>View your profile details from here!</h2>,
                placement: 'center',
                target: '#clientProfileDiv',
            },
            {
                content: <div className="tooltipDiv">Edit your profile details by pressing here!</div>,
                placement: 'left',
                target: '#editBtn',
            }
        ]
    });
    let helpers = null;

    // variables
    const { providerUniqueId } = useParams();

    // useEffects
    useEffect(() => {
        try {
            DemoService.getUserData().then(data => {
                if (data.isAuthenticated) {
                    if (data.user.roles[0] === "DemoClient") {
                        setUser(data.user);
                        data.client = clients[0];
                        setClient({
                            title: data.client.title,
                            firstName: data.client.firstName,
                            lastName: data.client.lastName,
                            email: data.client.email,
                            gender: data.client.gender,
                            birthDate: data.client.birthDate,
                            phone: data.client.phone,
                            address1: data.client.address1,
                            address2: data.client.address2,
                            city: data.client.city,
                            state: data.client.state,
                            country: data.client.country,
                            pincode: data.client.pincode,
                            profileImage: data.client.profileImage
                        });
                        if (!data.user.demoTakenFor.includes("ViewClientProfile")) {
                            setTutorial({ ...tutorial, status: true });
                        }
                    } else {
                        // props.history.replace('PagePath');
                    }
                } else {
                    props.history.replace('/demo/signin');
                }
            })
        }
        catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client ViewClientProfile useEffect', 'Error in try catch block', err.stack);
        }
    }, [])

    // handle functions
    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (!user.demoTakenFor.includes("ViewClientProfile")) {
                DemoService.markVisited("ViewClientProfile");
                setUser({ ...user, demoTakenFor: [...user.demoTakenFor, "ViewClientProfile"] });
            }
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    // function's return
    return (
        <div id="clientProfileDiv">
            <ErrorBoundary errorAt="At Client ClientProfile Joyride">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    getHelpers={getHelpers}
                    run={tutorial.status}
                    scrollToFirstStep={true}
                    showProgress={false}
                    showSkipButton={false}
                    steps={tutorial.steps}
                    locale={{ last: 'Finish' }}
                    styles={{
                        options: {
                            primaryColor: "rgb(56, 78, 115)",
                            zIndex: 10000,
                        },
                    }}
                />
            </ErrorBoundary>

            <ClientNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />

            <div className="mx-3 mt-3 row">
                <h1 id="profileText" style={theme.headingBold}>Profile</h1>
                <Link id="editBtn" className="ml-auto" to={"/demo/client/profile/edit"}>
                    <span id="editOption" style={{ color: colors.primary }}>
                        <i className="fas fa-edit"></i> Edit
                    </span>
                </Link>
            </div>

            <hr className="mx-3" style={{ borderWidth: "2px" }} />

            <div className="mt-5 row p-3">
                <div style={{ border: "5px solid", borderRadius: "10px", borderColor: colors.primary, background: colors.primary, maxWidth: "0px", maxHeight: "100%" }}></div>
                <div className="col-md-3 col-sm-3 col-11 py-3">
                    {/* <div style={{position: 'absolute', left: "5%", border: "5px solid", borderRadius: "10px", borderColor: colors.primary, maxWidth: "0px", minHeight: "100%"}}></div> */}
                    <div className="mx-auto text-center" style={{ width: "120px", height: "120px" }}>
                        <img id="profileImg" className="m-auto w-100 h-100" src={client.profileImage} alt="Counsellor" style={{ borderRadius: "100%", border: "solid 3px #C4C4C4" }} />
                    </div>
                </div>

                <div className="col-md-8 col-sm-8 col-11">
                    <h1 style={{ fontFamily: fontFamily.primary, fontSize: "2.5rem", fontWeight: fontWeight.medium }}>{client.title} {client.firstName} {client.lastName}</h1>

                    <p className="mt-4" style={theme.paragraph}>
                        <i className="fas fa-map-marker-alt"></i> <span>{client.city}, {client.state} - {client.country}</span>
                    </p>
                </div>
            </div>

            <p className="float-right" ><span style={theme.paragraphHeading}>Last Updated - </span><span style={theme.paragraph}>{moment(client.updatedAt).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).format('MMM DD, YYYY')}</span></p>

            <hr className="mt-5" />

            <div className="my-3 row p-3">

                <div className="col-md-6 col-sm-6 offset-md-3 offset-sm-3 col-12">
                    <p id="clientProfileEmail" className="m-0" style={theme.paragraphHeading}>Email</p>
                    <p id="clientProfileEmailValue" className="m-0" style={theme.paragraph}>{client.email}</p>

                    <br />

                    <p id="clientProfileGender" className="m-0" style={theme.paragraphHeading}>Gender</p>
                    <p id="clientProfileGenderValue" className="m-0" style={theme.paragraph}>{client.gender}</p>

                    <br />

                    <p id="clientProfileBirthDate" className="m-0" style={theme.paragraphHeading}>Birth Date</p>
                    <p id="clientProfileBirthDateValue" className="m-0" style={theme.paragraph}>{client.birthDate}</p>

                    <br />

                    <p id="clientProfileAddress" className="m-0" style={theme.paragraphHeading}>Address</p>
                    <p className="m-0" style={theme.paragraph}>{client.address1}</p>
                    <p className="m-0" style={theme.paragraph}>{client.address2}</p>

                    <br />

                    <p id="clientProfilePinCode" className="m-0" style={theme.paragraphHeading}>Pincode</p>
                    <p id="clientProfilePinCode" className="m-0" style={theme.paragraph}>{client.pincode}</p>

                    <br />

                    <p id="clientProfileCity" className="m-0" style={theme.paragraphHeading}>City</p>
                    <p id="clientProfileCityValue" className="m-0" style={theme.paragraph}>{client.city}</p>

                    <br />

                    <p id="clientProfileState" className="m-0" style={theme.paragraphHeading}>State</p>
                    <p id="clientProfileStateValue" className="m-0" style={theme.paragraph}>{client.state}</p>

                    <br />

                    <p id="clientProfileCountry" className="m-0" style={theme.paragraphHeading}>Country</p>
                    <p id="clientProfileCountryValue" className="m-0" style={theme.paragraph}>{client.country}</p>

                    <br />

                    <p id="clientProfileContactNumber" className="m-0" style={theme.paragraphHeading}>Contact Number</p>
                    <p id="clientProfileContactNumberValue" className="m-0" style={theme.paragraph}>{client.phone}</p>

                    <br />

                </div>



            </div>

            <Footer />

        </div>
    )
}

export default ViewClientProfile;